<template>
    <div class="overflow-auto pa-5 ma-0 d-flex flex-column">
        <h4>{{ $t('data_relations') }}</h4>
        <KpIcon v-if="loading" icon-cls="refresh ic-spin" color="primary" size="32" />
        <DependencyView :dependencies="dependencies" single full :message="null" />
    </div>
</template>

<script>
import { User } from '@/models/User';
import DependencyView from '@/components/DependencyView.vue';
import { mapActions } from 'vuex';

export default {
    name: 'UserRelations',
    components: {
        DependencyView,
    },
    mixins: [],
    props: {
        record: {
            type: User,
            required: true,
        },
    },
    data() {
        return {
            dependencies: [],
            loading: true,
            loadDependenciesOptions: {
                full: true,
            },
        };
    },
    async mounted() {
        await this.loadDependencies();
        this.loading = false;
    },
    methods: {
        ...mapActions(['runAsync']),

        async loadDependencies() {
            this.dependencies = await this.runAsync(
                async () => await this.record.listDependencies(this.loadDependenciesOptions),
            );
        },
    },
};
</script>

<style lang="scss" scoped></style>
